// Email capture for FAME calculator lead magnets.
// Writes to Supabase `leads` table (service-sites project ugmsgrbawrdcehdgdjin)
// and fires AgentMail via the /api/email-capture serverless endpoint.

import { supabase } from './supabase';

// FAME company_id (from companies table on service-sites Supabase)
const FAME_COMPANY_ID = '1520580a-cffc-4e09-bc12-626d0ddce98a';

export interface CalculatorCaptureInput {
  email: string;
  name?: string;
  slug: string;                    // calculator slug, e.g. "missed-calls"
  calculatorInputs: Record<string, number | string>;
  calculatorResults: Record<string, number | string>;
}

export async function captureCalculatorEmail(input: CalculatorCaptureInput) {
  const source = `calculator-${input.slug}`;

  // 1) Write to Supabase leads (non-blocking auth, uses anon key).
  const { error } = await supabase.from('leads').insert([
    {
      company_id: FAME_COMPANY_ID,
      email: input.email,
      owner_name: input.name ?? null,
      source,
      status: 'new',
      needs_report: true,
      audit_data: {
        site: 'floridaaimarketingexperts.com',
        calculator_slug: input.slug,
        inputs: input.calculatorInputs,
        results: input.calculatorResults,
        captured_at: new Date().toISOString(),
      },
    },
  ]);

  if (error) {
    // eslint-disable-next-line no-console
    console.error('[calculator] supabase insert error:', error);
  }

  // 2) Fire AgentMail serverless endpoint (best-effort).
  try {
    await fetch('/api/email-capture', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: input.email,
        name: input.name,
        source,
        calculator_slug: input.slug,
        inputs: input.calculatorInputs,
        results: input.calculatorResults,
      }),
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[calculator] email-capture endpoint not available yet:', e);
  }

  return { ok: !error };
}
